// extracted by mini-css-extract-plugin
module.exports = {"header__nav-section--full-width":"HeaderNavSection_header__nav-section--full-width__HQnJ_"};